//TEMP
// import '@angular/compiler';
import { enableProdMode } from '@angular/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { platformBrowser } from '@angular/platform-browser';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

document.addEventListener("DOMContentLoaded", () => {
  const style = document.querySelector('[data-primeng-style-id="global-style"]');
  if (style) {

    style.textContent = style.textContent.replace(
      /\*,::before,::after\{box-sizing:[^}]+\}/,
      ""
    );
  }
});

platformBrowser(providers).bootstrapModule(AppModule)
  .catch(err => {
    console.error('Error:', err);
  });

